import Vue from 'vue'

import iLogo from '@/assets/icons/logo.svg'
import iInfo from '@/assets/icons/general/info.svg'
import iChat from '@/assets/icons/general/chat.svg'
import iBell from '@/assets/icons/general/bell.svg'
import iMarker from '@/assets/icons/general/marker.svg'
import iWatch from '@/assets/icons/general/watch.svg'
import iCompanies from '@/assets/icons/general/companies.svg'
import iProfile from '@/assets/icons/general/profile.svg'
import iPayment from '@/assets/icons/general/payment.svg'
import iSettings from '@/assets/icons/general/settings.svg'
import iDistance from '@/assets/icons/general/distance.svg'
import iNoDriver from '@/assets/icons/general/no-driver.svg'
import iFilter from '@/assets/icons/general/filter.svg'
import iEmptySearch from '@/assets/icons/general/empty-search.svg'
import iFile from '@/assets/icons/general/file.svg'
import iPuma from '@/assets/icons/general/puma.svg'
import iRabit from '@/assets/icons/general/rabit.svg'
import iTurtle from '@/assets/icons/general/turtle.svg'
import iLogout from '@/assets/icons/general/logout.svg'

// User icons
Vue.component('i-logo', iLogo)
Vue.component('i-info', iInfo)
Vue.component('i-chat', iChat)
Vue.component('i-bell', iBell)
Vue.component('i-marker', iMarker)
Vue.component('i-watch', iWatch)
Vue.component('i-companies', iCompanies)
Vue.component('i-profile', iProfile)
Vue.component('i-payment', iPayment)
Vue.component('i-settings', iSettings)
Vue.component('i-distance', iDistance)
Vue.component('i-no-driver', iNoDriver)
Vue.component('i-filter', iFilter)
Vue.component('i-empty-search', iEmptySearch)
Vue.component('i-file', iFile)
Vue.component('i-puma', iPuma)
Vue.component('i-rabit', iRabit)
Vue.component('i-turtle', iTurtle)
Vue.component('i-logout', iLogout)

// States

// Cars
import carBasic from '@/assets/icons/cars/basic-car.svg'
import carBoxVan from '@/assets/icons/cars/box-van.svg'
import carDeliveryVan from '@/assets/icons/cars/delivery-van.svg'
import carDeliveryVanXl from '@/assets/icons/cars/delivery-van-xl.svg'
import carLightVan from '@/assets/icons/cars/light-van.svg'
import carSemiTrailer from '@/assets/icons/cars/semi-trailer.svg'
import carTruck5K from '@/assets/icons/cars/truck-5-ton.svg'
import carTruck10K from '@/assets/icons/cars/truck-10-ton.svg'
import carTruckTrailer from '@/assets/icons/cars/truck-trailer.svg'

Vue.component('car-basic', carBasic)
Vue.component('car-box-van', carBoxVan)
Vue.component('car-delivery-van', carDeliveryVan)
Vue.component('car-delivery-van-xl', carDeliveryVanXl)
Vue.component('car-light-van', carLightVan)
Vue.component('car-semi-trailer', carSemiTrailer)
Vue.component('car-truck-5k', carTruck5K)
Vue.component('car-truck-10k', carTruck10K)
Vue.component('car-truck-trailer', carTruckTrailer)

// Packages
import packageSmall from '@/assets/icons/packages/small.svg'
import packageMedium from '@/assets/icons/packages/medium.svg'
import packageLarge from '@/assets/icons/packages/large.svg'
import packageCustom from '@/assets/icons/packages/custom.svg'

import packageBoxed from '@/assets/icons/packages/boxed.svg'
import packageUnboxed from '@/assets/icons/packages/unboxed.svg'
import packagePallet from '@/assets/icons/packages/pallet.svg'

Vue.component('package-small', packageSmall)
Vue.component('package-medium', packageMedium)
Vue.component('package-large', packageLarge)
Vue.component('package-custom', packageCustom)
Vue.component('package-pallet', packagePallet)
Vue.component('package-pallet_iso', packagePallet)
Vue.component('package-pallet_euro', packagePallet)
Vue.component('package-box', packageBoxed)
Vue.component('package-unboxed', packageUnboxed)

// Extras
import extraBreakable from '@/assets/icons/extras/breakable.svg'
import extraFragile from '@/assets/icons/extras/breakable.svg'
import dangerousGoods from '@/assets/icons/extras/dangerous_goods.svg'
import frozen from '@/assets/icons/extras/frozen.svg'
import loadingBridgeRequired from '@/assets/icons/extras/loading_bridge_required.svg'
import noStacking from '@/assets/icons/extras/no_stacking.svg'
import refrigerated from '@/assets/icons/extras/refrigerated.svg'
import foodDonation from '@/assets/icons/extras/food_donation.svg'

Vue.component('extra-fragile', extraFragile)
Vue.component('extra-breakable', extraBreakable)
Vue.component('extra-dangerous-goods', dangerousGoods)
Vue.component('extra-frozen', frozen)
Vue.component('extra-loading-bridge-required', loadingBridgeRequired)
Vue.component('extra-no-stackable', noStacking)
Vue.component('extra-refrigerated', refrigerated)
Vue.component('extra-food-donation', foodDonation)
